// Strategy-scanner client — POST /Backtests/scan. Enumerates condition combos over the
// chosen indicators and returns the top candidates ranked by score.

import { fetchJson, URLS } from "./client";
import type { ScanRequestDto, ScanResponseDto } from "./types";

export function runScan(req: ScanRequestDto, signal?: AbortSignal): Promise<ScanResponseDto> {
  return fetchJson<ScanResponseDto>(`${URLS.historicalIndicators}/Backtests/scan`, {
    method: "POST",
    body: req,
    signal,
  });
}
